import React from 'react'
import {AutoComplete, CircularProgress, DatePicker, RaisedButton, TextField} from "material-ui";
import {blue500} from "material-ui/styles/colors";
import * as validator from "../../general/validators/validator";

const underlineStyle = {
    borderColor: blue500,
};

class ReportAddDetailsRow extends React.Component {
    render() {


        return (
            <div id={"parent"} style={{display: 'block', overflow: 'auto'}}>

                <div style={{textAlign: 'center'}}>
                    <TextField
                        disabled={true}
                        inputStyle={{color: 'black'}}
                        style={{width: 100}}
                        floatingLabelText="Cod articol"
                        type={"text"}
                        value={this.props.articleCode}
                    />
                    <TextField
                        disabled={!this.props.canUserEditAcquisitionsReports}
                        textareaStyle={{color: 'black'}}
                        style={{width: 250, marginLeft: '5px'}}
                        floatingLabelText="Denumire articol"
                        type={"text"}
                        value={this.props.realArticleName}
                        errorText={this.props.error.realArticleName}
                        onChange={this.props.onRealArticleNameChange}
                    />
                    <TextField
                        disabled={true}
                        textareaStyle={{color: 'black'}}
                        style={{width: 350, marginLeft: '5px'}}
                        floatingLabelText="Detalii articol"
                        type={"text"}
                        rowsMax={10}
                        value={this.props.articleDetails}
                        onChange={(e) => {}}
                    />
                    <TextField
                        disabled={!this.props.canUserEditAcquisitionsReports}
                        inputStyle={{color: 'black'}}
                        style={{width: 100, marginLeft: '5px'}}
                        floatingLabelText="Pret unitar"
                        type={"number"}
                        value={this.props.realPricePerUnit}
                        errorText={this.props.error.realPricePerUnit}
                        onChange={this.props.onRealPricePerUnitChange}
                    />

                    <TextField
                        disabled={!this.props.canUserEditAcquisitionsReports}
                        inputStyle={{color: 'black'}}
                        style={{width: 60, marginLeft: '5px'}}
                        floatingLabelText="Cantitate"
                        type={"number"}
                        value={this.props.realQuantity}
                        errorText={this.props.error.realQuantity}
                        onChange={this.props.onRealQuantityChange}
                    />

                    <TextField
                        disabled={true}
                        inputStyle={{color: 'black'}}
                        style={{width: 30, marginLeft: '5px'}}
                        floatingLabelText="TVA"
                        type={"number"}
                        value={this.props.vat}
                    />

                    <TextField
                        disabled={true}
                        inputStyle={{color: 'black'}}
                        style={{width: 200, marginLeft: '5px'}}
                        floatingLabelText="Valoare estimativa lei (fara TVA)"
                        type={"number"}
                        value={this.props.estimatedValueNoVat}
                    />
                </div>

                <div style={{width: '100%', display: 'flex', textAlign: 'left'}}>
                    <div style={{margin: '0 auto'}}>
                        <div>
                            <AutoComplete
                                underlineStyle={underlineStyle}
                                disabled={!this.props.canUserEditAcquisitionsReports}
                                floatingLabelText="Cauta alt cod CPV"
                                searchText={this.props.cpvSuggestionValue}
                                onUpdateInput={(val) => {
                                    this.props.onChangeCpvSuggestion(val);
                                }}
                                onNewRequest={(chosenRequest, index) => this.props.onCpvSuggestionsClearRequested(chosenRequest, index)}
                                dataSource={this.props.cpvSuggestions}
                                filter={AutoComplete.noFilter}
                                fullWidth={450}
                                multiLine={true}
                            />

                            <TextField
                                underlineStyle={underlineStyle}
                                inputStyle={{color: 'black'}}
                                disabled={!this.props.canUserEditAcquisitionsReports}
                                style={{width: 250, marginRight: '10px'}}
                                floatingLabelText="Cod CPV"
                                type={"text"}
                                errorText={this.props.error.cpvSelectedValue}
                                value={this.props.cpvSelectedValue}
                            />
                        </div>

                        <div>
                            <TextField
                                underlineStyle={underlineStyle}
                                inputStyle={{color: 'black'}}
                                disabled={!this.props.canUserEditAcquisitionsReports}
                                floatingLabelText="Credite bugetare aprobate"
                                type={"number"}
                                value={this.props.budgetaryApprovedCredits}
                                onChange={this.props.onBudgetaryApprovedCreditsChange}
                            />
                        </div>

                        <div>
                            <TextField
                                underlineStyle={underlineStyle}
                                inputStyle={{color: 'black'}}
                                disabled={!this.props.canUserEditAcquisitionsReports}
                                floatingLabelText="Angajament bugetar nr. si data"
                                type={"text"}
                                value={this.props.budgetaryCommitmentNumberDate}
                                onChange={this.props.onBudgetaryCommitmentNumberChange}
                            />
                        </div>

                        <div>
                            <TextField
                                underlineStyle={underlineStyle}
                                inputStyle={{color: 'black'}}
                                disabled={!this.props.canUserEditAcquisitionsReports}
                                style={{width: '350px'}}
                                floatingLabelText="Valoare angajament bugetar lei (cu TVA)"
                                type={"number"}
                                value={this.props.budgetaryCommitmentValueVat}
                                onChange={this.props.onBugdetaryCommitmentValueVatChange}
                            />
                        </div>

                        <div>
                            <TextField
                                underlineStyle={underlineStyle}
                                inputStyle={{color: 'black'}}
                                disabled={!this.props.canUserEditAcquisitionsReports}
                                floatingLabelText="Procedura de achizitie"
                                type={"text"}
                                value={this.props.acquisitionProcedure}
                                onChange={this.props.onAcquisitionProcedureChange}
                            />
                        </div>

                        <div>
                            <TextField
                                underlineStyle={underlineStyle}
                                inputStyle={{color: 'black'}}
                                disabled={!this.props.canUserEditAcquisitionsReports}
                                floatingLabelText="Ofertanti denumire firma"
                                type={"text"}
                                value={this.props.bidderCompanyName}
                                onChange={this.props.onBidderCompanyNameChange}
                            />
                        </div>

                        <div>
                            <TextField
                                underlineStyle={underlineStyle}
                                inputStyle={{color: 'black'}}
                                disabled={!this.props.canUserEditAcquisitionsReports}
                                floatingLabelText="Criteriu de evaluare a ofertelor"
                                type={"text"}
                                value={this.props.bidEvaluationCriterion}
                                onChange={this.props.onBidEvaluationCriterionChange}
                            />
                        </div>

                        <div>
                            <TextField
                                underlineStyle={underlineStyle}
                                inputStyle={{color: 'black'}}
                                disabled={!this.props.canUserEditAcquisitionsReports}
                                floatingLabelText="Valoare oferta lei fara TVA"
                                type={"number"}
                                value={this.props.bidValueNoVat}
                                onChange={this.props.onBidValueNoVatChange}
                            />
                        </div>
                    </div>

                    <div style={{margin: '0 auto'}}>
                        <div>
                            <TextField
                                underlineStyle={underlineStyle}
                                inputStyle={{color: 'black'}}
                                disabled={!this.props.canUserEditAcquisitionsReports}
                                style={{width: '150px'}}
                                floatingLabelText="Punctaj obtinut"
                                type={"number"}
                                value={this.props.obtainedPoints}
                                onChange={this.props.onObtainedPointsChange}
                            />
                        </div>

                        <div>
                            <TextField
                                underlineStyle={underlineStyle}
                                inputStyle={{color: 'black'}}
                                disabled={!this.props.canUserEditAcquisitionsReports}
                                style={{width: '350px'}}
                                floatingLabelText="Valoarea desemnata castigatoare lei (cu TVA)"
                                type={"number"}
                                value={this.props.winningBidPriceVat}
                                onChange={this.props.onWinningBidPriceVatChange}
                            />
                        </div>

                        <div>
                            <TextField
                                underlineStyle={underlineStyle}
                                inputStyle={{color: 'black'}}
                                disabled={!this.props.canUserEditAcquisitionsReports}
                                style={{width: '350px'}}
                                floatingLabelText="Număr angajament legal"
                                type={"text"}
                                value={this.props.numberLegalCommitment}
                                onChange={this.props.onValueLegalCommitmentVatChange}
                            />
                        </div>

                        <div>
                            <TextField
                                underlineStyle={underlineStyle}
                                inputStyle={{color: 'black'}}
                                disabled={!this.props.canUserEditAcquisitionsReports}
                                floatingLabelText="Factura nr. si data"
                                type={"text"}
                                value={this.props.billNrDate}
                                onChange={this.props.onBillNrDateChange}
                            />
                        </div>

                        <div>
                            <TextField
                                underlineStyle={underlineStyle}
                                inputStyle={{color: 'black'}}
                                disabled={(!this.props.canUserEditAccountingReports && !this.props.canUserEditAcquisitionsReports) || !this.props.billNrDate}
                                style={{width: '250px'}}
                                floatingLabelText="Plati efectuate: OP nr. si data"
                                type={"text"}
                                value={this.props.paymentOpNrDate}
                                onChange={this.props.onPaymentOpNrDateChange}
                            />
                        </div>

                        <div>

                            <TextField
                                underlineStyle={underlineStyle}
                                inputStyle={{color: 'black'}}
                                disabled={(!this.props.canUserEditAccountingReports && !this.props.canUserEditAcquisitionsReports) || !this.props.billNrDate}
                                style={{width: '250px'}}
                                floatingLabelText="Plati efectuate: Lei"
                                type={"number"}
                                value={this.props.paymentValue}
                                onChange={this.props.onPaymentValueChange}
                            />
                        </div>

                        <div>
                            <TextField
                                underlineStyle={underlineStyle}
                                inputStyle={{color: 'black'}}
                                disabled={!this.props.canUserEditAcquisitionsReports}
                                style={{width: '350px'}}
                                floatingLabelText="Angajamente legale ramase de plata"
                                type={"number"}
                                value={this.props.leftLegalCommitmets}
                                onChange={this.props.onLeftLegalCommitmetsChange}
                            />
                        </div>

                        <div>
                            <TextField
                                underlineStyle={underlineStyle}
                                inputStyle={{color: 'black'}}
                                disabled={(!this.props.canUserEditReceptionReports && !this.props.canUserEditAcquisitionsReports) || !this.props.billNrDate}
                                style={{width: '350px'}}
                                floatingLabelText="Nr. nota receptie"
                                type={"text"}
                                value={this.props.receptionNrNote}
                                onChange={this.props.onReceptionNrNoteChange}
                            />
                        </div>

                        <div>
                            <DatePicker
                                underlineStyle={underlineStyle}
                                inputStyle={{color: 'black'}}
                                disabled={ (!this.props.canUserEditReceptionReports && !this.props.canUserEditAcquisitionsReports) || !this.props.billNrDate}
                                onDismiss={() => this.props.onReceptionDateChange(null, "")}
                                floatingLabelText="Data intrarii"
                                value={this.props.receptionDate}
                                onChange={this.props.onReceptionDateChange}
                            />
                        </div>
                    </div>


                </div>
                <div style={{width: '100%'}}>

                    <div>
                        {(this.props.canUserEditAcquisitionsReports || this.props.canUserEditAccountingReports || this.props.canUserEditReceptionReports)
                        && <RaisedButton
                            style={{float: 'right', marginRight: '20%', marginBottom: '50px', marginTop: '20px'}}
                            primary
                            label={"Salveaza"}
                            onClick={() => this.props.onSaveClicked()}/>}

                        {this.props.savingInProgress &&
                        <CircularProgress style={{float: "right", marginRight: '5%', marginTop: '20px'}}/>}

                        {this.props.savingSuccessful &&
                        <strong style={{color: '#008000', float: 'right', marginRight: '5%', marginTop: '25px'}}>Salvarea s-a finalizat cu succes!</strong>}

                        {this.props.savingError &&
                        <strong style={{color: '#FF0000', float: 'right', marginRight: '5%', marginTop: '25px'}}>A aparut o eroare. Va rog
                            reincercati!</strong>}
                    </div>
                </div>


            </div>
        )
    }

}

export default ReportAddDetailsRow;